import { jwtDecode } from 'jwt-decode';
import { getAccessToken } from '@/services/tokenStore';

/**
 * Извлекает данные пользователя из JWT токена
 * @returns {Object|null} Объект с данными пользователя или null если токен недействителен
 */
export function getUserFromToken() {
  const token = getAccessToken();
  if (!token || token === 'null' || token === 'undefined') {
    return null;
  }

  try {
    const decoded = jwtDecode(token);
    
    // Проверяем, что токен не истек
    const currentTime = Date.now() / 1000;
    if (decoded.exp && decoded.exp < currentTime) {
      return null;
    }

    // Маппинг ролей для отображения
    const roleNameMap = {
      'user': 'Пользователь',
      'admin': 'Администратор', 
      'atameken_admin': 'Администратор Атамекен'
    };

    return {
      id: decoded.sub || decoded.identity,
      username: decoded.username || decoded.email,
      email: decoded.email || decoded.username,
      role: decoded.role,
      subscription_plan: decoded.subscription_plan || null,
      roleName: roleNameMap[decoded.role] || 'Неизвестная роль',
      permissions: decoded.permissions || [],
      onboarding: decoded.onboarding || null
    };
  } catch (error) {
    console.error('Ошибка декодирования токена:', error);
    return null;
  }
}

/**
 * Проверяет, действителен ли токен
 * @returns {boolean} true если токен действителен
 */
export function isTokenValid() {
  const token = getAccessToken();
  if (!token || token === 'null' || token === 'undefined') {
    return false;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return !decoded.exp || decoded.exp > currentTime;
  } catch (error) {
    return false;
  }
}

/**
 * Получает роль пользователя из токена
 * @returns {string} Роль пользователя или 'user' по умолчанию
 */
export function getUserRole() {
  const userData = getUserFromToken();
  return userData?.role || 'user';
}

/**
 * Получает имя пользователя из токена
 * @returns {string} Имя пользователя или пустая строка
 */
export function getUsername() {
  const userData = getUserFromToken();
  return userData?.username || '';
}

/**
 * Получает email пользователя из токена
 * @returns {string} Email пользователя или пустая строка
 */
export function getUserEmail() {
  const userData = getUserFromToken();
  return userData?.email || '';
}

export function getUserSubscriptionPlan() {
  const userData = getUserFromToken();
  return userData?.subscription_plan || null;
}
